'use client';

import { Cloud } from 'lucide-react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SetupStoreFormRow } from '@/components/setup/experience/SetupStoreFormRow';
import { Switch } from '@/components/ui/switch';
import type { SetupManualStoreFormData } from '@/components/setup/setupManualSchemas';

/**
 * Store-kind toggle. Turning this on marks the store as digital — the guided setup then drops the
 * shipping step entirely (no address, no rates) for everything after this first screen.
 */
export function SetupStoreDigitalProductField() {
  const { t } = useTranslation('setup');
  const { control } = useFormContext<SetupManualStoreFormData>();

  return (
    <SetupStoreFormRow
      label={t('experience.connect.storeForm.digitalProductLabel')}
      htmlFor="setup-store-digital-product"
      icon={Cloud}
      hint={t('experience.connect.storeForm.digitalProductHint')}
    >
      <Controller
        name="digitalProduct"
        control={control}
        render={({ field: { value, onChange } }) => (
          <Switch
            id="setup-store-digital-product"
            checked={value ?? false}
            onCheckedChange={onChange}
            aria-label={t('experience.connect.storeForm.digitalProductLabel')}
          />
        )}
      />
    </SetupStoreFormRow>
  );
}
